<div fxFill>
  <ng-container *ngIf="step == 'select_sound'">
    <div fxLayout="column" fxLayoutAlign="start left" fxFill>
      <div class="pa-1" fxLayout="row" fxLayoutAlign="end center">
        <div fxFlex="50" fxFlex.xs="70">
          <flex-search-input [formControl]="searchCtrl"></flex-search-input>
        </div>
      </div>

      <div class="pl-1 pr-1 existing-sound-list" fxFlex="1 0 1px" perfectScrollbar>
        <div fxLayout="row" class="existing-sound-row" *ngFor="let file of filteredRingtones; let i = index"
          (mouseenter)="showBtnSelects[i]=true" (mouseleave)="showBtnSelects[i]=false">
          <div fxFlex="grow" class="existing-sound-name" [matTooltip]="file.name">
            {{file.name}}
          </div>
          <div class="existing-sound-player">
            <fileentry-player-button *ngIf="file.public_id" [disabled]="disablePlaying(file)"
              [filePublicId]="file.public_id">
            </fileentry-player-button>
          </div>
          <div fxFlexLayout="end center">
            <button mat-icon-button color="warn" data-ci="button-delete-sound" (click)="deleteRingtone(file)">
              <mat-icon>delete</mat-icon>
            </button>
          </div>
        </div>
      </div>

      <div class="pa-1">
        <button data-ci="add-sound" mat-stroked-button color="accent" (click)="addSound()" class="button-add">
          <mat-icon class="icon-add">add</mat-icon>
          <span class="vertical-align">{{ 'reusable_sound.content.add_sound'|translate }}</span>
        </button>
      </div>
    </div>
  </ng-container>

  <ng-container *ngIf="step == 'add_sound'">
    <div class="pa-1" fxLayout="column" fxLayoutAlign="start left">
      <div [hidden]="showInputName == false">
        <mat-form-field class="full-width">
          <mat-label>{{ 'sound_manager.content.sound_file_name' | translate }}</mat-label>
          <input matInput data-ci="sound_name" type="text"
            [placeholder]="'sound_manager.content.sound_file_name' | translate" [(ngModel)]="newFileEntryOptions.name">
        </mat-form-field>
        <span *ngIf="errors.name" class="mat-text-warn">{{ errors.name|translate }}</span>
      </div>
      <h2> {{ 'fileentry.action.upload_file' | translate }} </h2>
      <div fxLayout="row">
        <app-file-upload class="full-width" (onFileChange)="fileLoadedForBrowser($event)" icon="music_note"
          [allowedExtensions]="allowedUploadExtensions" 
          [maxSize]="allowedMaxSize"
          [title]="'fileentry.action.upload_file_hint'|translate">
        </app-file-upload>
      </div>
      <!--sound-upload-row-->
    </div>
  </ng-container>

  <ng-container *ngIf="step == 'confirm_sound'">
    <div class="pa-1" fxLayout="column" fxLayoutAlign="start left">
      <div [hidden]="showInputName == false">
        <mat-form-field class="full-width">
          <mat-label>{{ 'sound_manager.content.sound_file_name' | translate }}</mat-label>
          <input matInput type="text" [placeholder]="'sound_manager.content.sound_file_name' | translate"
            [(ngModel)]="newFileEntryOptions.name">
        </mat-form-field>
        <span *ngIf="errors.name" class="mat-text-warn">{{ errors.name|translate }}</span>
      </div>

      <ng-container *ngIf="soundFile">
        <mat-card class="card-widge sound-name">
          <div mat-card-widget>
            <button mat-mini-fab mat-card-icon color="primary">
              <mat-icon>music_note</mat-icon>
            </button>
            <div fxFlex class="pl-1 pr-1">
              <span class="filename">
                {{soundFile.name}}
                <mat-icon color="primary">check</mat-icon>
              </span>
            </div>
            <button fxFlex="40px" mat-icon-button class="mat-text-muted" (click)="deleteSound()">
              <mat-icon>delete</mat-icon>
            </button>
          </div>
        </mat-card>

        <mat-card class="card-widge sound-file" *ngIf="canPlayLocalFile()">
          <div mat-card-widget>
            <span fxFlex class="filename">{{ newFileEntryOptions.name }}</span>
            <div fxFlex="50" class="pl-1 pr-1">
              <p>
                <audio-browser-player #audioPlayer [hideStop]="true" [file]="soundFile"></audio-browser-player>
              </p>
            </div>
            <button fxFlex="40px" mat-icon-button class="mat-text-muted" (click)="stopSound()">
              <mat-icon>close</mat-icon>
            </button>
          </div>
        </mat-card>

      </ng-container>
    </div>
  </ng-container>
</div>
